var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-block"},[_c('div',{staticClass:"videoWrapper"},[_c('iframe',{attrs:{"width":"100%","height":"405","src":`https://www.youtube.com/embed/${_vm._getYTlink(_vm.src)}?autoplay=${
					_vm.autoplay ? 1 : 0
				}`,"frameborder":"0","allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }